import { render, staticRenderFns } from "./UserProfileAnalysis.vue?vue&type=template&id=707161ac&scoped=true"
import script from "./UserProfileAnalysis.vue?vue&type=script&lang=js"
export * from "./UserProfileAnalysis.vue?vue&type=script&lang=js"
import style0 from "./UserProfileAnalysis.vue?vue&type=style&index=0&id=707161ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707161ac",
  null
  
)

export default component.exports